import { render } from "./SectionTypeFilter.vue?vue&type=template&id=6fad8f77"
import script from "./SectionTypeFilter.vue?vue&type=script&lang=js"
export * from "./SectionTypeFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__